/**
 * @generated SignedSource<<96e324409f3d9bd6947203ea4c1f66e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedContainer_item$data = {
  readonly isSold: boolean | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedCircles_item" | "PdpRespCondensedListedContent_item" | "PdpRespSellerItemTileCarousel_item" | "PdpRespSimilarItemsGrid_item" | "PdpRespSimilarItemsLanding_item" | "PdpSharedRecentHistoryTrackerDeprecated_item">;
  readonly " $fragmentType": "PdpRespCondensedContainer_item";
};
export type PdpRespCondensedContainer_item$key = {
  readonly " $data"?: PdpRespCondensedContainer_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedContainer_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedContainer_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRecentHistoryTrackerDeprecated_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespCondensedListedContent_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSellerItemTileCarousel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespCondensedCircles_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "578559eef28f24abccdc351b349ec774";

export default node;
